import { DataContext } from 'providers/data';
import Carousel from 'react-material-ui-carousel';
import { useContext, useEffect, useState } from 'react';

import { handleSomeProductFA } from 'core/dataProductsFA';

import { Box, Typography } from '@mui/material';

import Menu from 'components/views/Menu';
import NavTitle from 'components/views/NavTitle';
import ModalClube from 'components/views/ModalClube';
import CarouselCars from 'components/views/CarouselCars';
import { Banner } from 'components/views/ContainersPage';
import DetailsPlane from 'components/views/MyVehicles/DetailsPlane';
import DetailsVehicles from 'components/views/MyVehicles/DetailsVehicles';

import BannerClub from 'assets/images/banners/desk/banner-club-desk.png';

import BannerServicesAdd from 'assets/images/banners/desk/banner-services-add-desk.png';
import BannerDadosAtualizadosDesk from 'assets/images/banners/desk/banner-dados-atualizados-desk.png';
import { ReactComponent as IcAssistance24hrs } from 'assets/icons/ic-assistance-24hrs.svg';

import { Container, ContainerBody, ContentBody, BoxCustom, LinkCustom } from './styles';

const MyVehicles = () => {
    const [isProductFA, setIsProductFA] = useState(false);
    const [enabledRequest, setEnabledRequest] = useState(true);
    const [showModalClube, setShowModalClube] = useState(false);
    const { selectedCar, dataUsefulContacts, dataGetVirtualFencesHistory, handleGetUsefulContacts, handlePostGetVirtualFencesHistory } = useContext(DataContext);

    useEffect(() => {
        const dateNow = new Date();
        const dateOld = new Date();
        dateOld.setDate(dateOld.getDate() - 1);

        if ((selectedCar?.TECNOLOGIA === 2) && !dataGetVirtualFencesHistory && enabledRequest) {
            setEnabledRequest(false);
            handlePostGetVirtualFencesHistory({
                body: {
                    PocSag: selectedCar.POCSAG,
                    DtInicio: dateOld.toISOString(),
                    DtFim: dateNow.toISOString(),
                    Ativa: true
                }
            });

            setTimeout(() => {
                setEnabledRequest(true);
            }, 120000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar, dataGetVirtualFencesHistory, enabledRequest]);

    useEffect(() => {
        if (selectedCar) {
            if (!dataUsefulContacts) {
                handleGetUsefulContacts({ token: localStorage.getItem('token')! });
            }

            handleSomeProductFA(selectedCar.CD_PRODUTO) ? setIsProductFA(true) : setIsProductFA(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar]);

    return (
        <Container>
            <Menu>
                <ContainerBody>
                    <ContentBody>
                        <Typography fontSize='1.5625rem' fontWeight={700} color='rgba(141, 155, 181, 0.5)' lineHeight='30px' sx={{
                            width: '100%',
                            marginBottom: '1.64rem',
                            borderBottom: '1px solid rgba(141, 155, 181, 0.5)',
                            display: {
                                xs: 'none',
                                md: 'block'
                            }
                        }}>
                            MEUS VEÍCULOS
                        </Typography>
                        <Box sx={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <Box sx={{
                                width: {
                                    xs: '100%',
                                    md: '70%'
                                }
                            }}>
                                <CarouselCars />

                                <DetailsVehicles dataSelectedCar={selectedCar} />
                                <DetailsPlane dataSelectedCar={selectedCar} dataContactsUseFull={dataUsefulContacts} dataGetVirtualFencesHistory={dataGetVirtualFencesHistory} />
                            </Box>

                            <Box sx={{
                                width: '30%',
                                display: {
                                    xs: 'none',
                                    md: 'flex'
                                },
                                alignItems: 'center',
                                flexDirection: 'column',
                                justifyContent: 'start',
                            }}>
                                <Box sx={{ width: '100%', maxWidth: '14rem' }}>
                                    <NavTitle title={selectedCar?.COMODATO ? 'Fique ligado!' : 'Contrate'} />
                                    {selectedCar?.COMODATO ?
                                        [1079756].indexOf(selectedCar?.CODIGO_SEGURADORA) >= 0 ?
                                            <Carousel sx={{ width: '100%', 'button': { display: 'none' }, minHeight: '10rem' }}>
                                                <Banner bannerImg={BannerClub} link='' onClick={() => setShowModalClube(true)} />
                                                <Banner bannerImg={BannerDadosAtualizadosDesk} link='/meus-dados' />
                                            </Carousel>
                                            :
                                            <Banner bannerImg={BannerDadosAtualizadosDesk} link='/meus-dados' />
                                        :
                                        !isProductFA ?
                                            <Carousel sx={{ width: '100%', minHeight: '27.25rem', 'button': { display: 'none' } }}>
                                                <Banner bannerImg={BannerServicesAdd} link='/servicos-adicionais' />
                                                <Banner bannerImg={BannerClub} link='' onClick={() => setShowModalClube(true)} />
                                            </Carousel>
                                            :
                                            <BoxCustom>
                                                <LinkCustom href='https://api.whatsapp.com/send/?phone=5508000105566&text&type=phone_number&app_absent=0' target='_blank'>
                                                    <Typography
                                                        fontSize='1.25rem'
                                                        lineHeight='1.25rem'
                                                        fontWeight={400}
                                                        textAlign='center'
                                                        color='white'
                                                    >
                                                        Ainda não tem assistência 24h?
                                                    </Typography>
                                                    <IcAssistance24hrs />
                                                </LinkCustom>
                                                <Box sx={{
                                                    width: '100%',
                                                    height: '35%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: 'secondary.main',
                                                    borderRadius: '12px'
                                                }}>
                                                    <Typography
                                                        fontSize='1.5rem'
                                                        lineHeight='1.8rem'
                                                        fontWeight={700}
                                                        textAlign='center'
                                                        color='white'
                                                        sx={{
                                                            'strong': {
                                                                color: 'primary.main'
                                                            }
                                                        }}
                                                    >
                                                        Faça um
                                                        <br />
                                                        <strong>
                                                            UPGRADE!
                                                        </strong>
                                                    </Typography>
                                                </Box>
                                            </BoxCustom>
                                    }
                                </Box>
                            </Box>
                        </Box>
                    </ContentBody>

                    <ModalClube openModal={showModalClube} handleClickClosed={() => setShowModalClube(false)} />
                </ContainerBody>
            </Menu >
        </Container>
    );
}

export default MyVehicles;